<template>
  <v-toolbar id="header" class="elevation-2" clipped-left
    app fixed dark color="grey darken-4" v-if="currentUser && currentUser.logged">
    <v-toolbar-side-icon @click.stop="toggleMenuSmall"
      v-bind:class="{ active: showMenu }" v-if="$vuetify.breakpoint.mdAndUp">
      <v-icon>fal fa-bars</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-side-icon @click.stop="toggleMenu"
      v-bind:class="{ active: showMenu }" v-if="!$vuetify.breakpoint.mdAndUp">
      <v-icon>fal fa-bars</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-title>
      <router-link :to="{ path: '/' }">
        <img class="logo" src="/static/images/logo-white.png">
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-menu offset-y :content-class="'app-notifications-list'"
        :close-on-content-click="false">
        <v-btn slot="activator" flat>
          <v-badge color="deep-orange darken-2">
            <span slot="badge" v-if="notifications.length && showNotificationsCount">
              {{ notifications.length }}
            </span>
            <v-icon small>fal fa-bell</v-icon>
          </v-badge>
        </v-btn>
        <v-list>
          <app-notifications-list :notifications="notifications"></app-notifications-list>
        </v-list>
      </v-menu>
      <v-menu offset-y class="user-toolbar">
        <v-btn slot="activator" flat>
          <v-avatar size="32">
            <img :src="currentUser.avatar" height="32" v-if="currentUser.avatar">
            <v-icon color="grey lighen-4" v-else>fal fa-user-circle</v-icon>
          </v-avatar>
          <span class="name mx-2">{{ currentUser.first_name }}</span>
          <v-icon color="deep-orange darken-2">fal fa-angle-down</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="item in userMenu" :key="item.title" @click="go(item.routerName)">
            <v-list-tile-title>
              <v-icon small>{{ 'fal fa-' + item.icon }}</v-icon>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="logout()">
            <v-list-tile-title>
              <v-icon small>fal fa-power-off</v-icon> Sair
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import router from '@/router'
import axios from 'axios'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'
import AppNotificationsList from './AppNotificationsList'
const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export default {
  name: 'AppHeader',
  data: () => ({
    userMenu: [
      { title: 'Minha conta', icon: 'user', routerName: 'Account' }
    ],
    showMenu: false,
    menuSmall: true,
    notifications: [],
    showNotificationsCount: true
  }),

  methods: {
    go (routerName) {
      router.push({ name: routerName })
    },

    currentUserIsAdmin () {
      if (!currentUser || !currentUser.roles) return
      return currentUser.roles.indexOf('admin') !== -1
    },

    logout () {
      Auth.signOut().then(data => {
        localStorage.removeItem('currentUser')
        EventBus.$emit('appLoading', false)
        axios.defaults.headers.common['Authorization'] = null
        router.push({ name: 'Login' })
      })
    },

    toggleMenu () {
      this.showMenu = !this.showMenu
      EventBus.$emit('showMenu', this.showMenu)
    },

    toggleMenuSmall () {
      this.menuSmall = !this.menuSmall
      EventBus.$emit('menuSmall', this.menuSmall)
    },

    loadAlertNotifications (seen = false) {
      if (!currentUser) return
      // eslint-disable-next-line
      axios.get(`${API.notifications}/users/${currentUser._id}?seen=${seen}`).then(response => {
        this.notifications = response.data.notifications

        if (!seen && !response.data.notifications.length) {
          this.loadAlertNotifications(true)
          this.showNotificationsCount = false
        }
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadAlertNotifications')
  },

  created () {
    this.loadAlertNotifications()
    EventBus.$on('loadAlertNotifications', this.loadAlertNotifications)
  },

  props: {
    source: String,
    currentUser: Object
  },

  components: { AppNotificationsList }
}
</script>

<style src="../assets/scss/modules/header.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/modules/AppHeader.vue